module.exports = __webpack_public_path__ + "static/map-0d2b1d32e1b7ed5e5a5d77e29f26b57c.png";